import { useGlobalContext } from '@/components/Context/hooks/useGlobalContext';
import { LiquidButton } from '@/components/LiquidButton';
import { AVAILABLE_THEMES } from '@/styles/constants';

export const LiquidButtonElement = ({
  text = '',
  width,
  ctaColor = '#EFDBB2',
  textColor = '#000',
  isWidthAuto = false,
}: {
  text: string;
  width: number;
  ctaColor?: string;
  textColor?: string;
  isWidthAuto?: boolean;
}) => {
  const { themeName } = useGlobalContext();
  if (themeName === AVAILABLE_THEMES.suprema) {
    return <LiquidButton variant="primary" text={text} className="mt-5" />;
  }

  return (
    <LiquidButton
      text={text}
      height={50}
      width={width}
      color={ctaColor}
      isWidthAuto={isWidthAuto}
      textColor={textColor}
    />
  );
};
